<template>
  <div class="message-conatiner flex" :style="{'background-color': backgroundColor, 'border-color': borderColor}">
    <div class="m-r-10 message-box" style="align-self:flex-start;">
      <Icon
        class="m-r-20"
        :style="{'background-color': iconCircleColor}"
        :circle=true
        :fillColor="iconColor"
        :name="icon"
        size="22"/>
      </div>
      <div v-if="data.type=== 'validation'" class="message-message" v-html="data.data"></div>
      <div v-else-if="data.type=== 'custom-message'" class="custom-message" v-html="data.data"></div>
      <div v-else-if="data.type === 'row_error'" class="message-message">
        <div :style="{'color': textColor}" class="message-header m-b-10">{{$t(data.type)}}</div>
        <li :style="{'color': textColor}" class="m-b-10" v-for="(item, index) in data.errors" :key="`row-error-${index}`">
          <span>{{ $t(item.key) }}:&nbsp;{{ $t(item.message) }} {{ item.addition}}</span>
        </li>
      </div>
      <div v-else-if="data.message.type === 'header_error'" class="message">
      <div :style="{'color': textColor}" class="message-header m-b-10">{{$t(data.message.type)}}</div>
      <li :style="{'color': textColor}" class="m-b-10" v-for="(item, index) in data.message.errors" :key="`row-error-${index}`">
        <span>{{ item }}:&nbsp;{{ $t(data.message.message) }}</span>
      </li>
    </div>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'message',
  props: {
    name: {
      type: String,
      default: 'warning',
    },
    data: {
      type: Object,
      default: () => ({})
    },
    customIcon: {
      type: String,
      default: '',
    }
  },
  methods: {
    setMessageType() {
      if (this.name === 'warning') {
        this.textColor = '#755D32';
        this.icon = 'warningSign';
        this.iconCircleColor = '#F7F0C9';
        this.iconColor = '#755D32';
        this.backgroundColor = '#FCF8E3';
        this.borderColor = '#FAEBCC';
      }
      if (this.name === 'error') {
        this.textColor = '#755D32';
        this.icon = 'warningSign';
        this.iconCircleColor = '#ed5656';
        this.iconColor = '#fff';
        this.backgroundColor = '#ffdcda';
        this.borderColor = '#ffdcda';
      }
      if (this.customIcon) {
        this.icon = this.customIcon;
      }
    }
  },
  data() {
    return {
      textColor: '',
      iconCircleColor: '',
      backgroundColor: '',
      borderColor: '',
      iconColor: '',
      icon: ''
    }
  },
  created() {
    this.setMessageType()
  }
}
</script>
